module.exports = __webpack_public_path__ + "static/img/H6.7f20754a.jpg";